export default [
  {
    path: '/registry-offices',
    name: 'RegistryOfficesList',
    component: () => import('pages/registry-offices/RegistryOfficesList.vue')
  },
  {
    path: '/registry-offices/new',
    name: 'RegistryOfficesCreate',
    component: () => import('pages/registry-offices/RegistryOfficesForm.vue')
  },
  {
    path: '/registry-offices/:id/edit',
    name: 'RegistryOfficesEdit',
    component: () => import('pages/registry-offices/RegistryOfficesForm.vue')
  }
]
